import React from 'react';
import { RowsGreySeparator, Row } from './rows-grey-separator';
import classnames from 'classnames';
interface SelectableCards {
    keys: (string | number)[];
    onClickCard: Function;
    renderCard: Function;
    renderBadge: Function;
    disabled: Function;
    selected: string | number;
}

export const SelectableCards: React.FC<SelectableCards> = ({ keys, renderCard, onClickCard, selected, renderBadge, disabled }) => {
    return (
        <RowsGreySeparator>
            {keys.map((key: string | number, index) => {
                const handleClick = (key: string | number) => {
                    if (!disabled(key)) {
                        onClickCard(key, index);
                    }
                };
                const classes = classnames('selectable-card-wrapper', {
                    selected: selected === key,
                    'disable-hover': disabled(key)
                });
                return (
                    <Row key={key}>
                        {renderBadge(key)}
                        <div className={classes} onClick={() => handleClick(key)}>
                            {renderCard(key)}
                        </div>
                    </Row>
                );
            })}
        </RowsGreySeparator>
    );
};
